import React from "react";
import Skeleton from "react-loading-skeleton";
import styled from "styled-components";
import { InfoBarsLoader } from "Components/InfoBars/Loader";

export const Loader: React.FC = () => {
  return (
    <Container>
      <Skeleton height={25} width={250} />
      <InfoBarsLoaderContainer>
        <InfoBarsLoader />
      </InfoBarsLoaderContainer>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  text-align: center;
`;

const InfoBarsLoaderContainer = styled.div`
  margin-top: 40px;
`;
